import type { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@trello/nachos/button';
import { ExternalLinkIcon } from '@trello/nachos/icons/external-link';

import styles from './ErrorMessage.less';

interface ErrorMessageProps {
  transferUrl: string;
  errorMessage: string;
  isEnterpriseError: boolean;
  inviteRestrictionUrlFromEnterprise: string | undefined;
}

export const ErrorMessage: FunctionComponent<ErrorMessageProps> = ({
  transferUrl,
  errorMessage,
  isEnterpriseError,
  inviteRestrictionUrlFromEnterprise,
}) => {
  return (
    <div className={styles.errContainer}>
      <p>{errorMessage}</p>

      {isEnterpriseError && (
        <Button href={transferUrl} appearance="primary">
          <FormattedMessage
            id="templates.invitation_link.transfer-account"
            defaultMessage="Transfer account"
            description="Button to transfer account"
          />
        </Button>
      )}

      {inviteRestrictionUrlFromEnterprise && (
        <Button
          linkTarget="_blank"
          href={inviteRestrictionUrlFromEnterprise}
          className={styles.learnHow}
          appearance="primary"
        >
          <FormattedMessage
            id="templates.invitation_link.learn-how"
            defaultMessage="Learn how"
            description="Button to learn how"
          />
          <ExternalLinkIcon color="light" />
        </Button>
      )}
    </div>
  );
};
